import axios from 'axios'
import Vue from 'vue'
import Store from '@/store';
import Router from '@/router';
import { MessageBox, Message, Loading } from 'element-ui';

//创建axios
const service = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? '/api' : process.env.VUE_APP_BASE_URL,
    // baseURL: process.env.NODE_ENV === "development" ? 'https://guidelines.yuntsg.com/' : process.env.VUE_APP_BASE_URL,
    timeout: 60000,
    withCredentials: true
})

let messageBoxCount = 0,
    getTokenCount = 0,
    loadingCount = 0,    //打开 laoding  的个数
    loading;
let notGetToken = ['https://user.tsgyun.com/user/get-login-status']


// loading开始 方法
function startLoading () {
    loadingCount++;
    loading = Loading.service({
        text: '拼命加载中...',
        spinner: 'el-icon-loading',  // 自定义图标
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'loadingClass'
    })
}

// loading结束 方法
function loadingClose () {
    loadingCount--;
    loading.close()
}

// 请求拦截器
service.interceptors.request.use(config => {
    switch (config.requestBaseUrl) {
        case 'pm':
            config.baseURL = process.env.VUE_APP_PM_URL;
            break;
        case 'fulltext':
            config.baseURL = process.env.VUE_APP_FULL_URL;
            break;
        case 'allsearch':
            config.baseURL = process.env.VUE_APP_ALLSEARCH_URL;
            break;
        case 'local':
            config.baseURL = process.env.VUE_APP_LOCAL_URL;
            config.withCredentials = false;
            break;
    }

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=utf-8'

    const token = sessionStorage.getItem('token');

    if (token) {
        config.headers.Token = token;
    } else {
        if (getTokenCount == 0 && notGetToken.indexOf(config.url) == -1) {
            getTokenCount++
            Store.dispatch('getToken')
        }
    }

    if (config.requestLoading) {
        startLoading();
    }



    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use((res) => {
    // console.log('响应拦截器：', res)
    if (res.config.requestLoading) {
        loadingClose();
    }
    if (res.config.notHasCode) {   // 接口不返回 code  
        return res.data
    }

    // 未登录
    if (res.data.code == 1 || res.data.code == 4) {
        if (messageBoxCount == 0) {
            messageBoxCount++
            sessionStorage.removeItem('token')
            Store.commit('setUserInfo', null)
            MessageBox('您未进行登录或登录信息已过期, 去登录?', '提示', {
                type: 'warning'
            }).then(() => {
                messageBoxCount--
                window.open('https://user.tsgyun.com/user/ssologin?sid=675&returnUrl=' +
                    encodeURIComponent(window.location.href), '_self')
            }).catch(() => {
                messageBoxCount--
            });
        }
        return Promise.reject(res)
    }

    // 无权限
    if (res.data.code == 2) {
        Router.push('/noPermission')
        return Promise.reject(res)
    }

    if (res.data.code == 3 && (res.config.url.indexOf('unit_add_search_word') != -1 ||
        res.config.url.indexOf('jour_add_search_word') != -1 ||
        res.config.url.indexOf('search/search') != -1)) {
        return res.data
    }

    const articleUrls = [
        'article/enau', 'article/cnau', 'article/enkw', 'article/cnkw',
        'article/subject', 'article/articletype', 'article/zky',
        'article/zkydalei', 'article/zkyxiaolei', 'article/meshdalei',
        'article/mh', 'article/beidaxiaolei', 'article/beidadalei',
        'article/hexin'
    ];

    if (articleUrls.some(url => res.config.url.includes(url))) {
        return res;
    }
    if (res.data.code !== 0) {
        Message.error(res.data.msg || '请求数据失败')
        return Promise.reject(res)
    }

    return res.data

}, (error) => {
    // console.log('请求失败：', error);
    if (error.config && error.config.requestLoading) {
        loadingClose();
    }
    Message.error(error.toString())
    return Promise.reject(error)
})

export default service